<template>
  <ConfirmPopup></ConfirmPopup>
  <Panel header="Cập nhật tài khoản">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
      <div class="flex min-w-0 flex-col md:col-span-3">
        <label>Tên đăng nhập</label>
        <InputText id="username" type="text" v-model="userUpdate.username" />
      </div>
      <div class="flex min-w-0 flex-col md:col-span-3">
        <label>Mật khẩu(tối thiểu 6 ký tự)</label>
        <Password id="password" v-model="password" toggleMask :feedback="true" />
      </div>
      <div class="flex min-w-0 flex-col md:col-span-3">
        <label>Họ và tên</label>
        <InputText id="fullname" type="text" v-model="userUpdate.fullname" />
      </div>
      <div class="flex min-w-0 flex-col md:col-span-3">
        <label>Số điện thoại</label>
        <InputText id="phoneNumber" type="text" v-model="userUpdate.phoneNumber" />
      </div>
      <div class="flex min-w-0 flex-col md:col-span-3">
        <label>Chọn quyền hạn</label>
        <Dropdown
          id="permission"
          v-model="userUpdate.permission"
          :options="userPermission"
          optionLabel="label"
          optionValue="value"
          placeholder="Vui lòng chọn quyền hạn của tài khoản ..."
          @change="selectPermission"
        >
        </Dropdown>
      </div>

      <div
        class="flex min-w-0 flex-col md:col-span-3"
        v-if="userUpdate.permission == 'civilGroup'"
      >
        <label>Chọn tổ</label>
        <Dropdown
          id="civilGroup"
          v-model="userUpdate.idCivilGroup"
          :options="listCivilGroup"
          optionLabel="civilGroupName"
          placeholder="Vui lòng chọn tổ ..."
          :filter="true"
        >
        </Dropdown>
      </div>
    </div>

    <Button
      label="Cập nhật"
      icon="pi pi-sync"
      iconPos="left"
      @click="doUpdate()"
      class="mr-[2vw] w-[15vw]"
      :disabled="!valid"
    />

    <Button
      label="Xoá"
      severity="danger"
      icon="pi pi-user-minus"
      iconPos="left"
      class="w-[15vw]"
      @click="del()"
    />
  </Panel>

  <!-- Confirm Delete Modal -->
  <ConfirmDeleteModal
    v-model="showConfirmModal"
    :title="confirmTitle"
    :message="confirmMessage"
    :is-loading="isConfirming"
    @confirm="confirmDelete.confirm"
    @cancel="confirmDelete.cancel"
  />
</template>

<script lang="ts">
import { computed, ref } from "vue";
import AuthRepository from "@/services/AuthRepository";
import { useToast } from "@/ui/services/toast";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import moment from "moment";
import { UserUpdate } from "@/models/userUpdate";
import Ward from "@/models/Ward.models";
import CivilGroup from "@/models/CivilGroup.models";
import zaloRepository from "@/services/ZaloRepository";
import router from "@/router";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";
import { useConfirmDelete } from "@/composables/useConfirmDelete";

export default {
  components: {
    ConfirmDeleteModal,
  },
  props: {
    id: Number,
  },
  setup(props) {
    const router = useRouter();
    const userUpdate = ref({} as UserUpdate);
    const toast = useToast();
    const store = useStore();
    const password = ref("");
    const userPermission = ref([
      { label: "Tài khoản cấp tổ", value: "civilGroup" },
      { label: "Tài khoản cấp phường", value: "ward" },
      // { label: 'Tài khoản cấp quận', value: 'district' },
      { label: "Quản lý", value: "admin" },
    ]);
    const ward = ref({} as Ward);
    const civilGroup = ref({} as CivilGroup);
    const listWard = ref([] as Ward[]);
    const listCivilGroup = ref([] as CivilGroup[]);

    // Use confirm delete composable
    const confirmDelete = useConfirmDelete();
    const showConfirmModal = confirmDelete.isOpen;
    const confirmTitle = confirmDelete.title;
    const confirmMessage = confirmDelete.message;
    const isConfirming = confirmDelete.isLoading;

    if (!(store.state.permission == "admin")) {
      router.push({
        name: "home",
      });
    }

    const valid = computed(() => {
      console.log(
        "$$$$$$$############### debug permission: " + userUpdate.value.permission
      );
      if (userUpdate.value.permission == "civilGroup") {
        return (
          userUpdate.value.fullname &&
          userUpdate.value.username &&
          civilGroup.value.wardCode &&
          userUpdate.value.phoneNumber
        );
      } else if (userUpdate.value.permission == "ward") {
        return (
          userUpdate.value.fullname &&
          userUpdate.value.username &&
          userUpdate.value.phoneNumber
        );
      } else if (userUpdate.value.permission == "admin") {
        return (
          userUpdate.value.fullname &&
          userUpdate.value.username &&
          userUpdate.value.phoneNumber
        );
      }
    });

    AuthRepository.getUserById(props.id)
      .then((response) => {
        console.log("########$$$$$$$$$$$$$$$$$$$$ userUpdate: ");
        userUpdate.value = response.data;
        userUpdate.value.password = "";
        console.log(
          "########$$$$$$$$$$$$$$$$$$$$ userUpdate: " +
            JSON.stringify(userUpdate.value)
        );
      })
      .catch((err) => {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: err.response.data,
          life: 2000,
        });
      });

    const doUpdate = () => {
      if (
        password.value.trim().length < 6 &&
        password.value.trim().length > 0
      ) {
        toast.add({
          severity: "error",
          summary: "Thất bại",
          detail: "Mật khẩu không hợp lệ, vui lòng nhập lại mật khẩu",
          life: 2000,
        });
      } else {
        const temp = ref({} as UserUpdate);
        userUpdate.value.password = "";
        console.log(
          "#######$$$$$$$$$$$%%%%%%%%%%%%%%%%% doUpdate222222 civilGroup: " +
            JSON.stringify(civilGroup.value)
        );
        console.log(
          "#######$$$$$$$$$$$%%%%%%%%%%%%%%%%% doUpdate222222 ward: " +
            JSON.stringify(ward.value)
        );

        if (password.value.trim().length == 0) {
          userUpdate.value.password = "";
        } else {
          var md5 = require("md5");
          userUpdate.value.password = password.value.trim();
        }
        AuthRepository.updateUser(userUpdate.value)
          .then((response) => {
            console.log(
              "#######$$$$$$$$$$$%%%%%%%%%%%%%%%%% doUpdate222222: " +
                JSON.stringify(userUpdate.value)
            );
            toast.add({
              severity: "success",
              summary: "Cập nhật",
              detail: "Cập nhật thông tin tài khoản thành công",
              life: 2000,
            });
            // router.push({
            //   name: 'home'
            // });
          })
          .catch((err) => {
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response.data,
              life: 2000,
            });
          });
      }
    };

    const del = () => {
      confirmDelete.open({
        title: "Xác nhận xoá",
        message: "Bạn có chắc chắn muốn xoá tài khoản này?",
        onConfirm: async () => {
          try {
            await AuthRepository.deleteUser(userUpdate.value.id);
            toast.add({
              severity: "success",
              summary: "Thành công",
              detail: "Tài khoản đã được xoá thành công",
              life: 3000,
            });
            router.push({
              name: "userList",
            });
          } catch (err: any) {
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response?.data || "Xoá tài khoản không thành công",
              life: 3000,
            });
          }
        },
      });
    };

    const selectPermission = () => {
      listWard.value = [];
      //listCivilGroup.value = [];
      const wardtemp = ref({} as Ward);
      const civilGrouptemp = ref({} as CivilGroup);
      ward.value = wardtemp.value;
      civilGroup.value = civilGrouptemp.value;
      if (
        userUpdate.value.permission == "civilGroup" ||
        userUpdate.value.permission == "ward"
      ) {
        zaloRepository
          .getListWard()
          .then((response) => {
            listWard.value = response.data;
          })
          .catch((err) => {
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response.data,
              life: 2000,
            });
          });
      }
    };
    const selectWard = () => {
      listCivilGroup.value = [];
      // if((userUpdate.value.permission == "civilGroup"))
      {
        zaloRepository
          .getListCivilGroup()
          .then((response) => {
            listCivilGroup.value = response.data;
          })
          .catch((err) => {
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response.data,
              life: 2000,
            });
          });
      }
    };

    selectWard();
    const formatDateTime = (date) => {
      return moment(String(date)).format("DD/MM/YYYY");
    };

    return {
      userUpdate,
      doUpdate,
      del,
      formatDateTime,
      userPermission,
      password,
      listWard,
      listCivilGroup,
      ward,
      civilGroup,
      selectPermission,
      selectWard,
      valid,
      // Confirm delete modal
      showConfirmModal,
      confirmTitle,
      confirmMessage,
      isConfirming,
      confirmDelete,
    };
  },
};
</script>
